import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VRow, [_c("style", {
    tag: "component",
    attrs: {
      "type": "text/css"
    }
  }, [_vm._v("\n    .filterColorPreview-customPickerColor {\n      background: linear-gradient(60deg, " + _vm._s(_vm.currentCustomerColor) + ", " + _vm._s(_vm.currentCustomerColor) + "66) !important;\n    }\n  ")]), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_vm._l(_vm.colors, function (c) {
    return _c(VAvatar, {
      key: c,
      class: `mr-1 ${c === _vm.currentColor ? 'color-active' : ''} filterColorPreview-${c}`,
      attrs: {
        "size": "23"
      },
      on: {
        "click": function ($event) {
          return _vm.setColor(c);
        }
      }
    });
  }), _c(VAvatar, {
    class: `mr-1 ${_vm.currentColor.startsWith('customerColor') ? 'color-active' : ''} filterColorPreview-customPickerColor`,
    attrs: {
      "size": "23"
    },
    on: {
      "click": function ($event) {
        return _vm.setColor('customerColor');
      }
    }
  })], 2), _vm.currentColor.startsWith('customerColor') ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VColorPicker, {
    attrs: {
      "mode": "hexa",
      "hide-mode-switch": ""
    },
    on: {
      "update:color": _vm.setCustomColor
    },
    model: {
      value: _vm.currentCustomerColor,
      callback: function ($$v) {
        _vm.currentCustomerColor = $$v;
      },
      expression: "currentCustomerColor"
    }
  })], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };